import React from 'react';
import { Check } from 'lucide-react';
import { useEditorStore } from '../lib/editorStore';

interface SaveOptionsMenuProps {
  onClose: () => void;
}

export function SaveOptionsMenu({ onClose }: SaveOptionsMenuProps) {
  const autoSave = useEditorStore(state => state.autoSave);
  const setAutoSave = useEditorStore(state => state.setAutoSave);

  const handleAutoSaveToggle = () => {
    setAutoSave(!autoSave);
  };

  return (
    <div className="absolute top-full left-0 mt-2 w-48 bg-gray-800 border border-gray-700 rounded-lg shadow-lg overflow-hidden z-50">
      <div className="p-2">
        <button
          onClick={handleAutoSaveToggle}
          className="w-full flex items-center gap-2 px-3 py-2 text-sm text-gray-300 hover:bg-gray-700 rounded-lg transition-colors"
        >
          <div className="w-4 h-4 flex items-center justify-center">
            {autoSave && <Check className="w-3 h-3" />}
          </div>
          Auto-save
        </button>
      </div>
    </div>
  );
}
